import React, {lazy} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Completed from "./components/Esign/Completed";
import NiceModal from '@ebay/nice-modal-react';
import DateHelpers from "./helpers/DateHelpers";
import {ThemeProvider} from "@mui/material";
import {theme} from "./theme";
import SignWrapper from "./components/Esign/SignWrapper";
import ErrorPage from "./components/Esign/Steps/ErrorPage";
import CancelWrapper from "./components/Cancellation/CancelWrapper";
import CancelCompleted from "./components/Cancellation/CancelCompleted";
import PaymentFreeWrapper from "./components/PaymentFree/PaymentFreeWrapper";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

DateHelpers.registerAxiosDateParser()

// Split code, prevents downloading unnecessary stuff
const Sanity = lazy(() => import("./components/Admin/Sanity/Sanity"))
const Admin = lazy(() => import("./components/Admin/AuthWrapper"))
const App = lazy(() => import("./App"))

const router = createBrowserRouter([
  {
    path: "/",
    element: <App/>,
    errorElement: <ErrorPage/>,
    children: [
      {
        path: "sign/:hashId",
        element: <SignWrapper/>
      },
      {
        path: "sign/completed/:hashId",
        element: <Completed/>
      },
      {
        path: "cancel/:hashId",
        element: <CancelWrapper/>
      },
      {
        path: "cancel/:hashId/completed",
        element: <CancelCompleted/>
      },
      {
        path: "sign/:hashId/error",
        element: <ErrorPage/>
      },
      {
        path: "cancel/:hashId/error",
        element: <ErrorPage/>,
      },
      {
        path: "cancel/:hashId/completed/error",
        element: <ErrorPage/>
      },
      {
        path: "sign/completed/:hashId/error",
        element: <ErrorPage/>
      },
      {
        path: "betalingsfri/:hashId",
        element: <PaymentFreeWrapper/>
      },
      {
        path: "betalingsfri/:hashId/error",
        element: <ErrorPage/>
      },
    ]
  },
  {
    path: "admin/studio/*",
    element: <Sanity/>
  },
  {
    path: "admin/*",
    element: <Admin/>
  },
]);

// @ts-ignore
root.render(
  <React.StrictMode>
    {
      <ThemeProvider theme={theme}>
        {
          // @ts-ignore
          <NiceModal.Provider>
            <RouterProvider router={router}/>
          </NiceModal.Provider>
        }
      </ThemeProvider>
    }
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
